export const RESET_DAILY_LOSS_CONFIRM_MODAL_KEY = 'resetDailyLossModalShowed';
export const REWIND_MODAL_KEY = 'rewindModalShowed';
/**
 * Retrieves modal shown status from localStorage as a nested object
 * @param key - The main localStorage key (e.g., 'rewindModalShowed')
 * @param componentName - Component name for error logging (e.g., 'RewindTradingDayModal')
 * @returns Object with sub-keys mapped to boolean values
 */
export const getModalShownStatus = (key: string, componentName: string): Record<string, boolean> => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : {};
  } catch (error) {
    console.error(`[${componentName}] Failed to read from localStorage:`, error);
    return {};
  }
};

/**
 * Sets modal shown status in localStorage using nested object structure
 * @param key - The main localStorage key (e.g., 'rewindModalShowed')
 * @param subKey - The sub-key for this specific modal instance (e.g., '1', 'phase1:0:50')
 * @param shown - Boolean indicating if modal has been shown
 * @param componentName - Component name for error logging (e.g., 'RewindTradingDayModal')
 */
export const setModalShownStatus = (
  key: string,
  subKey: string,
  shown: boolean,
  componentName: string,
): void => {
  try {
    const currentData = getModalShownStatus(key, componentName);
    currentData[subKey] = shown;
    localStorage.setItem(key, JSON.stringify(currentData));
  } catch (error) {
    console.error(`[${componentName}] Failed to write to localStorage:`, error);
  }
};

/**
 * Set empty object in localStorage for the given key
 * Useful for clearing all modal preferences (e.g., when max loss is reached)
 * @param key - The main localStorage key to reset (e.g., 'rewindModalShowed')
 * @param logPrefix - For error logging
 */
export const resetLocalStorageItem = (key: string, logPrefix: string): void => {
  try {
    localStorage.setItem(key, JSON.stringify({}));
  } catch (error) {
    console.error(`[${logPrefix}] Failed to reset localStorage key "${key}":`, error);
  }
};
